import React from "react";
import { Button, Typography } from "antd";
import { Link } from "react-router-dom";
import { detectionLogo1 } from "../images";

const { Title } = Typography;

function HeaderPage() {
  return (
    <div>
      <div>
        <img src={detectionLogo1} alt="Detection Logo" />
      </div>
    </div>
  );
}

export default HeaderPage;
